import { SCALABLE_OBJECT_TYPES } from "../constants";

export const isObjectScalable = (obj: any) => SCALABLE_OBJECT_TYPES.indexOf(obj?.layerType) !== -1;
